import React, { Component } from "react";
import { LoadingCSS } from "./styles";

export class Loading extends Component {
  
  state = {
    valor: 0
  };

  constructor(props) {
    super(props);
  };
  
  render() {
    return (
      <LoadingCSS id="LoadingPage" className="cortina">
          <div id="load">
            <div className="circle"></div>
        </div>
      </LoadingCSS>
    );
  }
}
